import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface TypeDocuments {
  name: string;
  api_token: string;
}

export interface TypeDocumentsListInfor {
  errors: unknown;
  typeDocuments: TypeDocuments;
  isAuthenticated: boolean;
}

@Module
export default class TypeDocumentsModule
  extends VuexModule
  implements TypeDocumentsListInfor
{
  errors = {};
  typeDocuments = {} as TypeDocuments;
  isAuthenticated = !!JwtService.getToken();

  get TypeDocuments() {
    return this.typeDocumentsListData;
  }

  @Mutation
  [Mutations.TYPE_DOCUMENTS_LIST_DATA](TypeDocuments) {
    this.typeDocumentsListData = TypeDocuments;
  }

  @Action
  [Actions.TYPE_DOCUMENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/type_documents", payload)
        .then((data) => {
          this.context.commit(Mutations.TYPE_DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.TYPE_DOCUMENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("type_documents/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.TYPE_DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.TYPE_DOCUMENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/type_documents", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.TYPE_DOCUMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.TYPE_DOCUMENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/type_documents",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.TYPE_DOCUMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
